var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9a4 4 0 0 1 4-4h19v23H5V9Z",
    fill: "#2EBCFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23h11v5.5a5.5 5.5 0 0 1-5.5 5.5H22V23Z",
    fill: "#2EBCFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 43c2.225 0 4.31-.606 6.096-1.661l4.332 4.332a25.146 25.146 0 0 0 4.243-4.243l-4.332-4.332A11.944 11.944 0 0 0 43 31c0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12Zm0-5a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
    fill: "#985184"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 34A12.022 12.022 0 0 1 19 31c0-6.627 5.373-12 12-12 .681 0 1.35.057 2 .166v5.124A7 7 0 0 0 24.674 34h-5.296Z",
    fill: "#144496"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.b805b7e4ae24c692bebd5e0d15443bc2.svg";
export { ForwardRef as ReactComponent };